<template>
    <transition>
    <div class="container-fluid card-body">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Purchase </li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">RFQ (Quotations)</a></li>
                        </ol>
                    </div>
                    <div class="page-title-right float-right "> 
                        <button type="button" class="btn btn-primary float-right" @click="toggleCreateModal()">
                            Create New RFQ
                        </button> 
                    </div>
                </div>
            </div>
        </div>

        <!-- RFQ Create Modal -->
        <Modal @close="toggleCreateModal()" :modalActive="createModalActive">
            <div class="modal-content scrollbar-width-thin orderPreview" style="width: 600px;">
                <div class="modal-header"> 
                    <h3 style="width: 100%">Create Request for Quotation (RFQ)</h3>
                    <button @click="toggleCreateModal()" type="button" class="btn btn-default">X</button> 
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitRFQ">
                        <div class="form-group mb-3">
                            <label>Store Requisition</label>
                            <select class="form-control" v-model="rfqForm.store_requisition_id" required>
                                <option value="">Select Requisition</option>
                                <option v-for="req in requisitionList" :key="req.id" :value="req.id">
                                    {{ req.requisition_no }} ({{ req.requisition_date }})
                                </option>
                            </select>
                        </div>
                        <div class="form-group mb-3">
                            <label>RFQ Date</label>
                            <input type="date" class="form-control" v-model="rfqForm.rfq_date" required />
                        </div>
                        <div class="form-group mb-3">
                            <label>Expected Delivery Date</label>
                            <input type="date" class="form-control" v-model="rfqForm.expected_delivery_date" required />
                        </div>
                        <button type="submit" class="btn btn-success float-right" :disabled="isSubmit">
                            {{ isSubmit ? 'Saving...' : 'Save RFQ' }}
                        </button>
                    </form>
                </div>
            </div>
        </Modal>

        <!-- Add Quotation Modal -->
        <Modal @close="quoteModalActive = false" :modalActive="quoteModalActive">
            <div class="modal-content scrollbar-width-thin orderPreview" style="width: 700px;">
                <div class="modal-header"> 
                    <h3 style="width: 100%">Add Supplier Quotation</h3>
                    <button @click="quoteModalActive = false" type="button" class="btn btn-default">X</button> 
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitQuote">
                        <div class="row">
                            <div class="col-md-6 form-group mb-3">
                                <label>Supplier</label>
                                <select class="form-control" v-model="quoteForm.supplier_id" required>
                                    <option value="">Select Supplier</option>
                                    <option v-for="sup in suppliersList" :key="sup.id" :value="sup.id">{{ sup.name || sup.supplier_name }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 form-group mb-3">
                                <label>Quotation Date</label>
                                <input type="date" class="form-control" v-model="quoteForm.quotation_date" required />
                            </div>
                            <div class="col-md-6 form-group mb-3">
                                <label>Lead Time</label>
                                <input type="text" class="form-control" v-model="quoteForm.lead_time" placeholder="e.g. 7 Days" />
                            </div>
                            <div class="col-md-6 form-group mb-3">
                                <label>Payment Terms</label>
                                <input type="text" class="form-control" v-model="quoteForm.payment_terms" placeholder="e.g. Cash on Delivery" />
                            </div>
                        </div>
                        
                        <h4 class="mt-2 mb-2">Product Rates</h4>
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Product</th>
                                    <th>Req Qty</th>
                                    <th>Unit Price (BDT)</th>
                                </tr>
                            </thead>
                            <tbody v-if="isQuoteLoading">
                                <tr><td colspan="3" class="text-center">Loading RFQ products...</td></tr>
                            </tbody>
                            <tbody v-else-if="quoteForm.details.length > 0">
                                <tr v-for="(prod, index) in quoteForm.details" :key="index">
                                    <td>{{ prod.product_name }}</td>
                                    <td>{{ prod.quantity }}</td>
                                    <td>
                                        <input type="number" step="0.01" min="0" class="form-control" v-model="prod.unit_price" required placeholder="Price" />
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr><td colspan="3" class="text-center">No products found in this RFQ.</td></tr>
                            </tbody>
                        </table>
                        
                        <button type="submit" class="btn btn-success float-right" :disabled="isSubmitQuote || quoteForm.details.length === 0">
                            {{ isSubmitQuote ? 'Saving...' : 'Save Quotation' }}
                        </button>
                    </form>
                </div>
            </div>
        </Modal>

        <!-- Comparison Sheet Modal -->
        <Modal @close="toggleCompareModal()" :modalActive="compareModalActive">
            <div class="modal-content scrollbar-width-thin orderPreview" style="width: 900px;">
                <div class="modal-header"> 
                    <h3 style="width: 100%">Vendor Comparison Sheet - RFQ #{{ selectedRFQ ? selectedRFQ.rfq_no : '' }}</h3>
                    <button @click="toggleCompareModal()" type="button" class="btn btn-default">X</button> 
                </div>
                <div class="modal-body">
                    <div v-if="isCompareLoading" class="text-center p-4">
                        <div class="spinner-border text-primary" role="status"></div>
                        <h4 class="mt-2">Loading Comparison Data...</h4>
                    </div>
                    <div v-else-if="comparisonData && comparisonData.products && comparisonData.products.length > 0">
                        <div class="table-responsive">
                            <table class="table table-bordered table-centered table-nowrap w-100">
                                <thead class="table-light">
                                    <tr>
                                        <th>Product</th>
                                        <th class="text-center" v-for="supplier in comparisonData.suppliers" :key="supplier.quotation_id">
                                            {{ supplier.name }}
                                            <div style="font-size: 11px; font-weight: normal; margin-top: 5px;" v-if="supplier.lead_time || supplier.payment_terms">
                                                <div v-if="supplier.lead_time">Lead Time: {{ supplier.lead_time }}</div>
                                                <div v-if="supplier.payment_terms">Terms: {{ supplier.payment_terms }}</div>
                                            </div>
                                            <div class="mt-1">
                                                <button v-if="supplier.status !== 1" class="btn btn-xs btn-outline-primary" style="padding: 2px 5px; font-size: 11px;" @click="approveQuote(supplier.quotation_id)">Approve</button>
                                                <span v-else class="badge bg-success">Approved</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="product in comparisonData.products" :key="product.id">
                                        <td>{{ product.name }}<br><small class="text-muted">Qty: {{ product.requested_quantity }}</small></td>
                                        <td class="text-center" v-for="supplier in comparisonData.suppliers" :key="supplier.quotation_id" :class="{'table-success fw-bold': isLowestBid(product.id, supplier.quotation_id, comparisonData.quotations)}">
                                            <span v-if="getQuotePrice(product.id, supplier.quotation_id, comparisonData.quotations)">
                                                BDT {{ getQuotePrice(product.id, supplier.quotation_id, comparisonData.quotations) }}
                                            </span>
                                            <span v-else class="text-muted">No Bid</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="text-center p-4">
                        <i class="mdi mdi-alert-circle-outline text-muted" style="font-size: 3rem;"></i>
                        <h4 class="mt-2 text-muted">No Data Found</h4>
                        <p class="text-muted mb-0">This RFQ does not have any products or supplier quotations yet.</p>
                    </div>
                </div>
            </div>
        </Modal>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body">
                        <div class="tableFilters mb-3" v-if="!loading">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="control" style="float: left;">
                                        <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                        <div class="select" style="float: left;">
                                            <select class="form-select" v-model="tableData.length" @change="fetchData()"> 
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>
                                        <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                    </div>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-4">
                                    <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search RFQs..." @input="fetchData()">
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered table-centered table-nowarp w-100" v-if="!loading">
                            <thead class="table-light">
                                <tr class="border success item-head">
                                    <th class="text-center" width="5%">SL </th>
                                    <th class="text-center" width="15%">RFQ No</th>
                                    <th class="text-center" width="20%">Requisition ID</th>
                                    <th class="text-center" width="15%">Status</th>
                                    <th class="text-center" width="15%">Deadline</th>
                                    <th class="text-center" width="10%">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="items.length > 0">
                                <tr class="border" v-for="(item, index) in items" :key="index">
                                    <td class="text-center">{{ (pagination && pagination.currentPage ? (pagination.currentPage - 1) * tableData.length : 0) + index + 1 }} </td>
                                    <td class="text-center">{{ item.rfq_no }} </td> 
                                    <td class="text-center">{{ item.store_requisition_id }} </td> 
                                    <td class="text-center">
                                        <span class="badge" :class="{
                                            'bg-secondary': item.status == 0,
                                            'bg-info': item.status == 1,
                                            'bg-primary': item.status == 2,
                                            'bg-success': item.status == 3
                                        }">
                                            {{ item.status == 0 ? 'OPEN' : (item.status == 1 ? 'QUOTED' : (item.status == 2 ? 'AWARDED' : 'CLOSED')) }}
                                        </span>
                                    </td>
                                    <td class="text-center">{{ item.rfq_date }} </td> 
                                    <td class="text-center actions"> 
                                        <button class="btn btn-sm btn-info" @click="viewComparison(item)">
                                            <i class="mdi mdi-scale-balance"></i> Comparison Sheet
                                        </button>
                                        <button class="btn btn-sm btn-primary ms-1" style="margin-left: 5px;" @click="toggleQuoteModal(item)">
                                            <i class="mdi mdi-plus"></i> Add Quote
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="6" class="text-center">No RFQs found.</td>
                                </tr>
                            </tbody>
                        </table>
                        <Pagination 
                            v-if="pagination && items.length > 0"
                            :pagination="pagination"  
                            :language="lang"
                            @onChangePage="setPage" > 
                        </Pagination> 
                        <div class="tab-pane show active" v-if="loading">
                            <div class="text-center p-4"> 
                                <div class="spinner-border text-primary" role="status"></div>
                                <h4 class="mt-2">Loading data...</h4>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script> 
import Modal from "./../helper/Modal";  
import Pagination from '@/components/Pagination.vue'; 
import axios from 'axios';  
export default {
    name: 'RFQList',
    components: {
        Modal,
        Pagination
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            isSubmitQuote: false,
            isCompareLoading: false,
            isQuoteLoading: false,
            createModalActive: false,
            compareModalActive: false,
            quoteModalActive: false,
            items: [],
            suppliersList: [],
            requisitionList: [],
            selectedRFQ: null,
            comparisonData: null,
            rfqForm: {
                store_requisition_id: '',
                rfq_date: '',
                expected_delivery_date: ''
            },
            quoteForm: {
                rfq_id: '',
                supplier_id: '',
                quotation_date: '',
                details: []
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: 0,
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: 0,
                to: 0,
                links: []
            },
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                sortKey: 'id'
            },
            lang: {
                lengthMenu: 'Show _MENU_ entries',
                info: 'Showing _FROM_ to _TO_ of _TOTAL_ entries',
                zeroRecords: 'No data available in table.', 
                search: 'Search'
            }
        };
    },
    created() {
        this.fetchData();
    },
    methods: { 
        fetchData(url = this.apiUrl+'/rfq') { 
            this.loading = true;
            this.tableData.draw++;
            axios.get(url, { params: this.tableData, ...this.headerjson })
            .then((res) => {
                let responseData = res.data.data || res.data;
                if (responseData && responseData.data && Array.isArray(responseData.data)) {
                    this.items = responseData.data;
                    this.configPagination(responseData);
                } else if (Array.isArray(responseData)) {
                    this.items = responseData;
                    this.pagination = null;
                }
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchSuppliers() {
            axios.get(this.apiUrl+'/suppliers', this.headerjson)
            .then(res => {
                let list = res.data.data || res.data;
                if (list && list.data && Array.isArray(list.data)) {
                    this.suppliersList = list.data;
                } else if (Array.isArray(list)) {
                    this.suppliersList = list;
                }
            });
        },
        fetchRequisitions() {
            axios.get(this.apiUrl+'/store_requisitions?for_rfq=1', this.headerjson)
            .then(res => {
                let list = res.data.data || res.data;
                if (list && list.data && Array.isArray(list.data)) {
                    this.requisitionList = list.data;
                } else if (Array.isArray(list)) {
                    this.requisitionList = list;
                }
            });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },
        setPage(data) {  
            this.fetchData(data.url); 
        },
        toggleCreateModal() {
            this.createModalActive = !this.createModalActive;
            this.rfqForm = { store_requisition_id: '', rfq_date: '', expected_delivery_date: '' };
            if (this.createModalActive) {
                this.fetchRequisitions();
            }
        },
        submitRFQ() {
            this.isSubmit = true;
            axios.post(this.apiUrl+'/rfq', this.rfqForm, this.headerjson)
            .then((res) => {
                this.$toast.success("RFQ created successfully");
                this.toggleCreateModal();
                this.fetchData();
            }).catch(err => {
                this.$toast.error(err.response?.data?.message || "Error creating RFQ");
            }).finally(() => {
                this.isSubmit = false;
            });
        },
        toggleQuoteModal(item) {
            this.selectedRFQ = item;
            this.quoteForm = {
                rfq_id: item.id,
                supplier_id: '',
                quotation_date: new Date().toISOString().split('T')[0],
                lead_time: '',
                payment_terms: '',
                details: []
            };
            this.quoteModalActive = true;
            this.isQuoteLoading = true;
            this.fetchSuppliers();
            // Fetch RFQ details for products
            axios.get(this.apiUrl+'/rfq/'+item.id, this.headerjson)
            .then(res => {
                const rfqData = res.data.data || res.data;
                const rfqDetails = Array.isArray(rfqData.rfq_details) ? rfqData.rfq_details : [];
                this.quoteForm.details = rfqDetails.map(d => ({
                    product_id: d.product_id,
                    product_name: d.product ? d.product.product_name : 'Unknown',
                    unit_id: d.product_unit_id,
                    quantity: d.quantity || 0,
                    unit_price: ''
                }));
            })
            .catch(err => {
                this.$toast.error(err.response?.data?.message || "Error loading RFQ details.");
            }).finally(() => {
                this.isQuoteLoading = false;
            });
        },
        submitQuote() {
            this.isSubmitQuote = true;
            axios.post(this.apiUrl+'/supplier_quotations', this.quoteForm, this.headerjson)
            .then(res => {
                this.$toast.success("Quotation added successfully");
                this.quoteModalActive = false;
                this.selectedRFQ = null;
                this.quoteForm.details = [];
            }).catch(err => {
                this.$toast.error(err.response?.data?.message || "Error saving quotation");
            }).finally(() => {
                this.isSubmitQuote = false;
            });
        },
        toggleCompareModal() {
            this.compareModalActive = !this.compareModalActive;
            if (!this.compareModalActive) {
                this.comparisonData = null;
                this.selectedRFQ = null;
            }
        },
        viewComparison(item) {
            this.selectedRFQ = item;
            this.compareModalActive = true;
            this.isCompareLoading = true;
            axios.get(this.apiUrl+'/rfq/'+item.id+'/comparison_sheet', this.headerjson)
            .then((res) => {
                this.comparisonData = res.data.data || res.data;
            })
            .catch((err) => {
                this.$toast.error(err.response?.data?.message || "Error fetching comparison sheet.");
            })
            .finally(() => {
                this.isCompareLoading = false;
            });
        },
        approveQuote(quotationId) {
            this.$swal({
                title: 'Approve Quotation?',
                text: "Are you sure you want to approve this quotation and generate a Purchase Order?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#10b981', // Professional green for approve
                cancelButtonColor: '#f43f5e', // Professional red for cancel
                confirmButtonText: 'Yes, approve it!'
            }).then((result) => {
                if (result.value || result.isConfirmed) {
                    axios.post(this.apiUrl+'/supplier_quotations/'+quotationId+'/approve', {}, this.headerjson)
                    .then(res => {
                        this.$toast.success("Quotation approved and PO generated!");
                        this.compareModalActive = false;
                        this.comparisonData = null;
                        this.selectedRFQ = null;
                        this.fetchData();
                    })
                    .catch(err => {
                        this.$toast.error(err.response?.data?.message || "Error approving quotation");
                    });
                }
            });
        },
        getQuotePrice(productId, quotationId, quotations = []) {
            if (!Array.isArray(quotations)) return null;
            const quote = quotations.find(q => q.quotation_id == quotationId && q.product_id == productId);
            return quote ? quote.unit_price : null;
        },
        isLowestBid(productId, quotationId, quotations = []) {
            if (!Array.isArray(quotations)) return false;
            const productQuotes = quotations.filter(q => q.product_id == productId);
            if(productQuotes.length === 0) return false;
            const minPrice = Math.min(...productQuotes.map(q => parseFloat(q.unit_price) || Infinity));
            const currentQuote = productQuotes.find(q => q.quotation_id == quotationId);
            return currentQuote && parseFloat(currentQuote.unit_price) === minPrice;
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    }
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin.orderPreview { 
    width: 900px;
}
.table-success {
    background-color: #d1e7dd !important;
}
.fw-bold {
    font-weight: bold;
}
</style>
